export default __webpack_public_path__ + "locales/fr/JavascriptSdk.json?hash=3bf74e0651054c78a2710981b1cdac69";